export default "__VITE_ASSET__CsQCVVwb__"